
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.857 11.947c0 .929.596 1.718 1.429 2.01v-3.194H8.857v1.184zm4.164-2.605A2.143 2.143 0 0011 7.921c-.933 0-1.727.593-2.02 1.421h4.04zm.122 1.421h-1.429v3.195a2.133 2.133 0 001.429-2.01v-1.185z","fill":"#1C274C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.788 21.788a.723.723 0 000-1.022L18.122 17.1a9.157 9.157 0 10-1.022 1.022l3.666 3.666a.723.723 0 001.022 0zM8.19 7.86A3.572 3.572 0 0111 6.5c1.14 0 2.157.532 2.81 1.36l.68-.338a.716.716 0 01.958.318.709.709 0 01-.319.953l-.679.338c.08.294.121.603.121.922v.236h.715c.394 0 .714.319.714.711 0 .392-.32.71-.714.71h-.715v.237c0 .32-.042.628-.12.922l.678.338a.709.709 0 01.32.953.716.716 0 01-.959.318l-.68-.338A3.572 3.572 0 0111 15.5a3.572 3.572 0 01-2.81-1.36l-.68.338a.716.716 0 01-.958-.318.709.709 0 01.319-.953l.679-.338a3.54 3.54 0 01-.121-.922v-.236h-.715A.712.712 0 016 11c0-.392.32-.71.714-.71h.715v-.237c0-.32.042-.628.12-.922l-.678-.338a.709.709 0 01-.32-.953.716.716 0 01.959-.318l.68.338z","fill":"#1C274C"}})])
          )
        }
      }
    